import { QueryObserver, QueryObserverOptions } from '@tanstack/query-core';

import { checkCurrentUser } from '../../shared-services/src/users/api';
import { getUserProperties } from '../../users/src/core/api';
import { queryClient } from '../core/queryClient';

type CheckCurrentUserResult = Awaited<ReturnType<typeof checkCurrentUser>>;
type UserPropertiesResult = Awaited<ReturnType<typeof getUserProperties>>;
export type CurrentUserResult = CheckCurrentUserResult & { properties: UserPropertiesResult };
type CurrentUserQueryOptions = Omit<QueryObserverOptions<CurrentUserResult>, 'queryKey' | 'queryFn'>;

export const currentUserQueryKey = () => ['current-user'];

export const currentUserQuery = (options?: CurrentUserQueryOptions): QueryObserver<CurrentUserResult> =>
  new QueryObserver<CurrentUserResult>(queryClient, {
    queryKey: currentUserQueryKey(),
    queryFn: async () => {
      const [currentUser, properties] = await Promise.all([checkCurrentUser(), getUserProperties()]);
      return { ...currentUser, properties };
    },
    ...options
  });
